
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export interface NoDataMessage {
  title: string
  subtitle?: string
}

export default defineComponent({
  name: 'NoData',
  props: {
    message: {
      type: Object as PropType<NoDataMessage>,
      required: true,
    },
    hasDataIcon: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const baseClass = 'epb-no-data'

    const getImageUrl = function (image: string): string {
      return require(`../../assets/media/image/highlights/${image}.webp`)
    }

    return {
      baseClass,
      getImageUrl,
    }
  },
})
